module.exports = __webpack_public_path__ + "static/woman-on-the-beach-desktop.71418ec4.webp";